import { styled, Typography } from '@mui/material';

const SanctionTitle = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '13px',
});

export default SanctionTitle;
